import { Route, Switch, Redirect, useParams } from 'react-router-dom';

import ClientLevelEventAnalytics from './Pages/Events/ClientLevelEventAnalytics';
import EventLevelEventAnalytics from './Pages/Events/EventLevelEventAnalytics';
import SessionLevelEventAnalytics from './Pages/Events/SessionLevelEventAnalytics';

// import ClientLevelSurveyAnalytics from './Pages/Surveys/ClientLevelSurveyAnalytics';
// import EventLevelSurveyAnalytics from './Pages/Surveys/EventLevelSurveyAnalytics';
// import SessionLevelSurveyAnalytics from './Pages/Surveys/SessionLevelSurveyAnalytics';

import PageHeader from './components/Scaffolding/PageHeader';
import { PATHNAMES } from "../admin";
import './Analytics.scss';
import useTranslationModules from '../../../i18n/useTranslationModules';


const AnalyticsRouter = (): JSX.Element => {
	const { tab, eventUuid, sessionUuid }: { tab?: string, eventUuid?: string, sessionUuid?: string; } = useParams();

	useTranslationModules({ language: "en" });

	switch (tab) {
		// case "surveys":
		// 	return sessionUuid ? <SessionLevelSurveyAnalytics /> : eventUuid ? <EventLevelSurveyAnalytics /> : <ClientLevelSurveyAnalytics />;
		default:
			return sessionUuid ? <SessionLevelEventAnalytics /> : eventUuid ? <EventLevelEventAnalytics /> : <ClientLevelEventAnalytics />;
	}
};

function Analytics(): JSX.Element {
	// const [activeTab, setActiveTab] = useState('Events');

	return (
		<div className="analytics">
			<Switch>
				<Route path="/admin/analytics/:tab/:eventUuid?/:sessionUuid?" >
					<PageHeader />
					<AnalyticsRouter />
				</Route>
				<Route>
					{/* TODO: fallback route redirects to event tab for now, post mvp implement tabbing from Params */}
					<Redirect to={`${PATHNAMES.AnalyticsLink}/events`} />
				</Route>
			</Switch>
		</div>
	);
}

export default Analytics;
